import { Controller } from "@hotwired/stimulus"

// FAQ page: live search + topic chips. Groups with no visible question hide,
// and an empty state shows when nothing matches. A #question-id in the URL
// opens that question.
export default class extends Controller {
  static targets = ["query", "chip", "group", "item", "empty"]

  connect() {
    this.topic = ""
    const linked = location.hash && this.itemTargets.find((item) => "#" + item.id === location.hash)
    if (linked) linked.open = true
  }

  pick(event) {
    this.topic = event.currentTarget.dataset.topic
    this.chipTargets.forEach((chip) => {
      const selected = chip === event.currentTarget
      chip.classList.toggle("is-selected", selected)
      chip.setAttribute("aria-pressed", String(selected))
    })
    this.filter()
  }

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()
    let shown = 0
    this.groupTargets.forEach((group) => {
      const inTopic = !this.topic || group.dataset.topic === this.topic
      const items = this.itemTargets.filter((item) => group.contains(item))
      let visible = 0
      items.forEach((item) => {
        const match = inTopic && (!query || item.textContent.toLowerCase().includes(query))
        item.hidden = !match
        if (match) visible++
      })
      group.hidden = visible === 0
      shown += visible
    })
    this.emptyTarget.hidden = shown > 0
  }
}
